<template>
  <!-- 管线成图列表页面 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="用户选择:">
              <a-select v-model="query.phone" placeholder="请选择用户" allowClear showSearch :filterOption="filterUserOption"
                @change="handleUserChange">
                <a-select-option v-for="item in userOptions" :key="item.id" :value="item.phone">
                  {{ item.userName + ' ' + item.phone }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="采集项目名称:">
              <a-input v-model="query.projectName" placeholder="请输入项目名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-button type="primary" @click="queryList">查询</a-button>
            <a-button style="margin-left: 18px" @click="resetList">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!--表单内容-->
    <a-table size="middle" rowKey="id" bordered :data-source="list" :columns="columns" :pagination="pagination"
      @change="handleTableChange">
      <template slot="projectCategoryAction" slot-scope="text">
        <span v-if="text == 1">给水</span>
        <span v-else-if="text == 2">排水</span>
        <span v-else-if="text == 3">燃气</span>
        <span v-else-if="text == 4">热力</span>
      </template>
      <template slot="matchStatus" slot-scope="text, record">
        <span v-if="text == 0" style="color: #05db0d">匹配成功</span>
        <div v-else-if="text == 1" style="color: #f42626; display: flex; align-items: center; justify-content: center">
          匹配失败
          <img @click="getmatching(record.id)" src="@/assets/collectionMappingSystem/gth.png"
            style="width: 12px; height: 12px; margin-left: 2px; cursor: pointer"
            v-if="$auth('pipeline-mapping.edit')" />
        </div>
      </template>
      <template slot="action" slot-scope="text, record">
        <img title="管线成图" :src="require(`@/assets/collectionMappingSystem/tomap.svg`)"
          style="margin-right: 8px; width: 18px; height: 18px; cursor: pointer" @click="showpoint(record.id)" />
        <img title="重新编号" :src="require(`@/assets/collectionMappingSystem/cxbh.svg`)"
          style="margin-right: 8px; width: 18px; height: 18px; cursor: pointer" @click="showRenumberModal(record)"
          v-action:edit />
        <img title="导出" :src="require(`@/assets/collectionMappingSystem/export.svg`)"
          style="margin-right: 8px; width: 18px; height: 18px; cursor: pointer" @click="showExportDialog(record)" />

        <a-popconfirm title="确定要删除这条记录吗?" ok-text="确定" cancel-text="取消" @confirm="() => handleDelete(record.id)"
          v-action:del>
          <a-tooltip>
            <img title="删除" :src="require(`@/assets/collectionMappingSystem/delete.svg`)"
              style="width: 18px; height: 18px; cursor: pointer" />
          </a-tooltip>
        </a-popconfirm>
      </template>
    </a-table>

    <!--坐标匹配弹窗-->
    <a-modal :visible.sync="coordinateDialogVisible" width="30%" @cancel="coordinateDialogVisible = false"
      :footer="null">
      <div class="gth">
        <div>
          <img src="@/assets/collectionMappingSystem/gth.png" style="width: 25px; height: 25px; margin-right: 10px" />
        </div>
        <span style="font-weight: bold; font-size: 16px">请注意</span>
      </div>
      <div style="color: red; margin-top: 20px; margin-bottom: 10px">以下管点没有找到对应的坐标</div>
      <div style="background-color: rgb(247, 247, 247); padding: 5px 0">
        <div v-for="item in matchFailedList" :key="item.id"
          style="color: black; text-align: center; margin-bottom: 5px">
          {{ item.intuitionPoint }}
        </div>
      </div>
    </a-modal>

    <!--导出弹窗-->
    <a-modal title="数据导出" :visible="exportDialogVisible" @ok="handleExport" @cancel="exportDialogVisible = false"
      :confirmLoading="exportLoading">
      <a-form :form="exportForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="导出类型">
          <a-select v-model="deriveType">
            <a-select-option value="excel"> 导出点线表（Excel表格） </a-select-option>
            <a-select-option value="cad"> 导出DXF文件 </a-select-option>
          </a-select>
          <!-- <a-input value="导出点线表（Excel表格）" disabled /> -->
        </a-form-item>

        <a-form-item label="模板选择" v-if="deriveType == 'excel'">
          <a-select v-decorator="['templateId', { rules: [{ required: true, message: '请选择模板' }] }]"
            placeholder="请选择导出模板" @change="handleTemplateChange">
            <a-select-option v-for="item in templateList" :key="item.id" :value="item.id">
              {{ item.templateName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <!-- <a-form-item label="文件命名">
          <a-input
            v-decorator="['fileName', { rules: [{ required: true, message: '请输入文件名称' }] }]"
            placeholder="请输入导出文件名称"
          />
        </a-form-item> -->
      </a-form>
    </a-modal>

    <!--重新编号弹窗-->
    <a-modal title="重新编号" :visible="renumberModalVisible" width="35%" :footer="null" @cancel="handleRenumberCancel">
      <div style="font-weight: bolder">参数设置</div>
      <div style="margin: 20px 0 10px 24px">当前项目：{{ currentProject.projectName }}</div>
      <div style="padding: 10px 24px; background-color: #ededed">
        <p>样式：JS1 → <span style="font-weight: bold">JS + 组号 + 虚拟号 </span> → JS100001</p>
        <div style="display: flex; align-items: center">
          <span class="bt">组号：</span>
          <a-input-number v-model="groupNumber" :min="1" :max="999" style="margin-right: 5px" />
          虚拟数：<a-input-number v-model="vacantPosition" :min="1" :max="5" style="margin-right: 5px" />
          虚拟生成：<a-input style="width: 100px" v-model="scvacantPosition" :disabled="true" />
        </div>
      </div>
      <div style="text-align: center; margin: 16px 0">
        <a-button type="primary" @click="previewRenumber" style="background-color: #1890ff; border-color: #1890ff"
          :loading="previewLoading">
          {{ previewLoading ? '加载中...' : '查看结果预览' }}
        </a-button>
      </div>
      <div v-if="renumberDataSource.length > 0">
        <div style="font-weight: bold; margin-bottom: 8px">匹配后结果预览</div>
        <a-table :scroll="{ y: 200 }" :dataSource="renumberDataSource" :bordered="true" :columns="renumberColumns"
          :pagination="false" />

        <div style="text-align: right; margin-top: 16px">
          <a-button @click="handleRenumberCancel">取消</a-button>
          <a-button type="primary" @click="submitRenumber" :loading="submitLoading"
            style="margin-left: 8px; background-color: #1890ff; border-color: #1890ff" v-action:edit>
            {{ submitLoading ? '编号中...' : '重新编号' }}
          </a-button>
        </div>
      </div>
    </a-modal>

    <!-- 加载动画组件 -->
    <loading-spinner :visible="submitting" :is-success="loadingSpinnerSuccess" text="写入数据中" />
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import axios from 'axios'
export default {
  mixins: [mixinViewModule],
  name: 'PipelineMappingList',
  components: {
    LoadingSpinner,
  },
  data () {
    return {
      queryUrl: '/gis-manager/diagramming/project/page?isPicture=1', // 修改查询URL
      list: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
      coordinateDialogVisible: false,
      deriveType: 'excel',
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 70,
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '用户名称',
          dataIndex: 'userName',
        },
        {
          title: '手机号码',
          dataIndex: 'phone',
        },
        {
          title: '采集项目名称',
          dataIndex: 'projectName',
        },
        {
          title: '采集项目类型',
          dataIndex: 'projectCategory',
          scopedSlots: { customRender: 'projectCategoryAction' },
        },
        {
          title: '采集单位',
          dataIndex: 'acquisitionUnits',
        },
        {
          title: '作业小组',
          dataIndex: 'assignmentGroup',
        },
        {
          title: '负责人',
          dataIndex: 'responsiblePerson',
        },
        // {
        //   title: '成图时间',
        //   dataIndex: 'mappingTime',
        // },
        {
          title: '成图时间',
          dataIndex: 'updateTime',
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: 120,
          align: 'center',
        },
      ],
      query: {
        phone: undefined,
        projectName: '',
        matchStatus: undefined,
      },
      userOptions: [],
      matchFailedList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
      },
      exportDialogVisible: false,
      exportLoading: false,
      templateList: [],
      selectedTemplateType: null,
      exportForm: this.$form.createForm(this),
      currentProjectId: null,
      exportDataUrl: '',
      renumberModalVisible: false,
      currentProject: { projectName: '' },
      groupNumber: 1,
      vacantPosition: 1,
      scvacantPosition: '',
      renumberDataSource: [],
      renumberColumns: [
        {
          title: '物探点号',
          dataIndex: 'intuitionPoint',
          align: 'center',
          width: 120,
        },
        {
          title: '变换后',
          width: 100,
          dataIndex: 'afterTheChange',
          align: 'center',
        },
      ],
      previewLoading: false,
      submitLoading: false,
      submitting: false,
      loadingSpinnerSuccess: false,
    }
  },
  created () {
    this.getUserList()
    this.queryList()
  },
  methods: {
    async getUserList () {
      try {
        const res = await this.$http.get('/gis-manager/user/deploy/user/list/1')
        if (res.code === 0) {
          this.userOptions = res.data || []
        } else {
          this.$message.error(res.message || '获取用户列表失败')
        }
      } catch (error) {
        console.error('获取用户列表失败:', error)
        this.$message.error('获取用户列表失败')
      }
    },
    handleUserChange (value) {
      this.query.phone = value
      this.queryList()
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, current: pagination.current, pageSize: pagination.pageSize }
      this.queryList() // 重新获取数据
    },
    queryList () {
      const params = {
        ...this.query,
        page: this.pagination.current,
        limit: this.pagination.pageSize,
      }

      if (!params.phone) {
        delete params.phone
      }

      this.$http
        .get(this.queryUrl, { params })
        .then((res) => {
          if (res.code === 0) {
            this.list = res.data.list || []
            this.pagination.total = Number(res.data.total || 0)
          } else {
            this.$message.error(res.message || '获取数据失败')
          }
        })
        .catch((error) => {
          console.error('获取列表数据失败:', error)
          this.$message.error('获取数据失败')
        })
    },
    resetList () {
      this.query = {
        phone: undefined,
        projectName: '',
        matchStatus: undefined,
      }
      this.pagination.current = 1
      this.queryList()
    },
    filterUserOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getmatching (id) {
      this.$http.get('/gis-manager/diagramming/project/list/' + id).then((res) => {
        this.matchFailedList = res.data
        this.coordinateDialogVisible = true
      })
    },
    async handleDelete (id) {
      try {
        const res = await this.$http.get(`/gis-manager/diagramming/project/remove/${id}`)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.queryList() // 重新加载列表数据
        } else {
          this.$message.error(res.message || '删除失败')
        }
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error('删除失败')
      }
    },
    // 显示导出弹窗
    showExportDialog (record) {
      this.currentProjectId = record.id // 保存当前选中的项目id
      this.deriveType = 'excel'
      this.exportDialogVisible = true
      this.getTemplateList()
    },

    // 获取模板列表
    async getTemplateList () {
      try {
        const res = await this.$http.get('/gis-manager/foundation/template/all/list')
        if (res.code === 0) {
          this.templateList = res.data || []
        } else {
          this.$message.error(res.message || '获取模板列表失败')
        }
      } catch (error) {
        console.error('获取模板列表失败:', error)
        this.$message.error('获取模板列表失败')
      }
    },

    // 选择模板时记录模板类型
    handleTemplateChange (value) {
      const template = this.templateList.find((item) => item.id === value)
      if (template) {
        this.selectedTemplateType = template.templateType
      }
    },

    // 处理导出
    async handleExport () {
      if (this.deriveType == 'excel') {
        this.exportForm.validateFields(async (err, values) => {
          if (err) return

          this.exportLoading = true
          try {
            // 设置导出URL
            if (this.selectedTemplateType === 1) {
              this.exportDataUrl = 'gis-manager/diagramming/point/export/list'
            } else if (this.selectedTemplateType === 2) {
              this.exportDataUrl = 'gis-manager/diagramming/pipe/export/list'
            }

            // 设置查询参数
            this.query = {
              templateId: values.templateId,
              projectManagementId: this.currentProjectId,
            }

            // 使用common.js中的导出方法
            this.exportHandle()
            this.exportDialogVisible = false
          } catch (error) {
            console.error('导出失败:', error)
            this.$message.error('导出失败')
          } finally {
            this.exportLoading = false
          }
        })
      } else if (this.deriveType == 'cad') {
        // 1. 直接使用后端完整URL（跳过任何本地代理）
        try {
          // 使用封装好的下载方法
          await this.downloadBinaryFile(
            `/gis-manager/diagramming/project/generate/${this.currentProjectId}`,
            {},
            'cad.dxf'
          )
          this.$message.success('DXF文件下载成功')
          this.exportDialogVisible = false
        } catch (error) {
          this.$message.error(error.response?.data?.message || 'DXF文件下载失败')
        } finally {
          this.exportLoading = false
        }
      }
    },

    async showpoint (currentProjectId) {
      const routeUrl = this.$router.resolve({
        path: '/gather-mapping/PipelineMapping',
        query: {
          currentProjectId: currentProjectId,
        },
      })
      window.open(routeUrl.href, '_blank')

    },

    showRenumberModal (record) {
      // 重置所有状态
      this.currentProject = record
      this.groupNumber = 1
      this.vacantPosition = 1
      this.scvacantPosition = '0'
      this.renumberDataSource = []
      this.previewLoading = false
      this.submitLoading = false
      this.submitting = false
      this.loadingSpinnerSuccess = false
      // 显示弹窗
      this.renumberModalVisible = true
    },

    handleRenumberCancel () {
      this.renumberModalVisible = false
    },

    previewRenumber () {
      if (!this.groupNumber) {
        this.$message.error('请填写组号！')
        return
      }
      this.previewLoading = true
      this.$http
        .post('/gis-manager/pipeline/point/renumber', {
          projectManagementId: this.currentProject.id,
          groupNumber: this.groupNumber,
          vacantPosition: this.scvacantPosition,
        })
        .then((res) => {
          if (res.code === 0) {
            this.renumberDataSource = res.data
            this.$message.success('预览成功')
          } else {
            this.$message.error(res.message || '预览失败')
          }
        })
        .catch((error) => {
          console.error('预览失败:', error)
          this.$message.error('预览失败，请重试')
        })
        .finally(() => {
          this.previewLoading = false
        })
    },

    submitRenumber () {
      this.submitLoading = true
      this.submitting = true
      this.$http
        .post('/gis-manager/pipeline/point/renumber/save', this.renumberDataSource)
        .then((res) => {
          if (res.code === 0) {
            this.loadingSpinnerSuccess = true
            setTimeout(() => {
              this.submitting = false
              this.loadingSpinnerSuccess = false
              this.renumberModalVisible = false
              this.queryList() // 刷新列表
            }, 1000)
          } else {
            this.$message.error(res.message || '重新编号失败')
            this.submitting = false
          }
        })
        .catch((error) => {
          console.error('重新编号失败:', error)
          this.$message.error('重新编号失败，请重试')
          this.submitting = false
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
  },
  watch: {
    vacantPosition (n) {
      let num = '1' + '0'.repeat(n)
      this.scvacantPosition = num.substring(1)
    },
  },
}
</script>

<style lang="less" scoped>
.gth {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}

/deep/.table-striped {
  background-color: #fafafa;
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}

.tab {
  font-size: 16px;
  font-weight: normal;
  border-collapse: collapse;

  tr td {
    height: 50px;
    border: 1px solid #d5ecfc;
  }

  tr th {
    width: 33.33%;
    height: 50px;
  }
}

.bt:before {
  content: '* ';
  color: red;
}

.preview-btn-wrapper {
  text-align: center;
  margin: 10px 0;
}

.footer-btns {
  text-align: right;
  margin-top: 16px;
  padding-right: 8px;

  .ant-btn {
    margin-left: 8px;
  }
}
</style>
